import { z } from "zod";

/**
 * Semantic label colour tokens (the web maps them to `--label-*` in tokens.css; `violet` is an alias of
 * `purple`, which is what the GitHub importer stores). Colours are never raw hex.
 */
export const LABEL_COLORS = [
  "gray",
  "red",
  "orange",
  "yellow",
  "green",
  "teal",
  "blue",
  "purple",
  "violet",
  "pink",
] as const;
export const LabelColor = z.enum(LABEL_COLORS);
export type LabelColor = z.infer<typeof LabelColor>;
